import React from 'react';
import cx from 'classnames';
import { FiArrowDown, FiArrowUp } from 'react-icons/fi';
import { useIntl } from 'react-intl';
import { SkeletonSimple } from '~components/skeleton';
import Radio from '~components/forms/radio';

const SortInFilter = ({ 
  value, 
  onChange = () => {}, 
  order, 
  className, 
  isLoading,
}) => {
  const intl = useIntl();

  const handleChange = (val) => {
    onChange(val);
  };

  if (isLoading) {
    return <SkeletonSimple theme="primary" className="c-skeleton-simple__item c-skeleton-simple__matches-sort" />;
  }

  return (
    <div
      className={cx('c-matches__sort_new', {
        [className]: !!className,
      })}
    >
      <Radio.Container 
        value={value ? `${value.value}-${value.direction}` : ''}
        onChange={(selectedValue) => {
          const selectedOption = order.find(o => `${o.value}-${o.direction}` === selectedValue);
          if (selectedOption) {
            handleChange(selectedOption);
          }
        }}
        className="c-vertical-nav c-sort-nav-list"
      >
        {order.map((o) => (
          <Radio.Option
            key={`${o.value}-${o.direction}`}
            value={`${o.value}-${o.direction}`}
            className="l-bordered"
          >
            {o.label}
            {o.arrowDown && <FiArrowDown className="c-listing__sort-item-arrow" />}
            {o.arrowUp && <FiArrowUp className="c-listing__sort-item-arrow" />}
          </Radio.Option>
        ))}
      </Radio.Container>
    </div>
  );
};

export default SortInFilter;
